var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationJob = function SvgLocationJob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.98 22.41c2.062-1.925 8.354-8.144 8.354-12.335 0-5.012-4.03-9.075-9-9.075s-9 4.063-9 9.075c0 4.19 6.292 10.41 8.354 12.335a.939.939 0 0 0 1.292 0ZM12.334 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    fill: "#272727"
  })));
};
export default SvgLocationJob;